// extracted by mini-css-extract-plugin
export default {"title":"BlockCard_title__lXu86","text":"BlockCard_text__ikzLe"};